// src/pages/beta-community/components/FeaturesSection.jsx
import React from 'react';

const FeaturesSection = () => {
  const features = [
    {
      icon: '🤖',
      title: 'Intelligence Artificielle',
      description: 'Classification stylistique, conservation, valorisation assistée, OCR documentaire et lecture transversale des collections selon les droits de chaque profil.'
    },
    {
      icon: '⛓️',
      title: 'Traçabilité & sécurité',
      description: 'Certificats d\'authenticité infalsifiables, traçabilité complète de la provenance, et smart contracts pour prêts et locations.'
    },
    {
      icon: '👥',
      title: 'Collaboration',
      description: 'Partage sécurisé avec experts, collaborateurs, Art Advisors ou Family Offices, avec permissions adaptées au rôle de chacun.'
    }
  ];

  return (
    <section className="section features-section">
      <div className="container">
        <h2 className="section-title">Une plateforme pensée pour les usages réels</h2>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;